import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import {
  arrow_icon,
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
} from "../../../assets/img";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import { checkPermission } from "../../redux/api/PermissionManager";
import { useAsyncDebounce } from "react-table";
import { Table } from "../../../components/Table/Table";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import { get, patch, post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";

const CheckIn = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");

  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    search: paginationData?.[path]?.search ?? "",
  });
  const [list, setList] = useState([]);
  const [addPopup, setAddPopup] = useState(false);
  const [tip, setTip] = useState("");
  const [names, setNames] = useState([]);
  const [deletePopup, setDeletePopup] = useState(false);
  console.log("tips ", tip);
  const handleChangeFilter = (name, val) => {
    setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [page, selectedFilter]);

  const getList = async (pageNumber = 1) => {
    let res = await get(
      `${URLS.MASTERURL}?type=${27}&page=${pageNumber}&search=${
        selectedFilter.search
      }`
    );
    console.log("wishlist res", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList(res?.data ?? []);
    }
  };

  const handleStatus = async ({ id, status }) => {
    const formdata = new FormData();
    formdata.append("status", !status);
    const res = await post(`${URLS.MASTERURL}${id}/status/`, formdata);
    if (res?.status === "success") {
      toast.success(res?.message || "Status updated");
      getList(page);
    }
  };

  const handleDelete = async (id) => {
    const res = await post(`${URLS.MASTERURL}${id}/delete/`);
    console.log("res delete check in", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList(page);
      setDeletePopup(false);
    }
  };

  const submit = async () => {
    let edit = typeof addPopup === "object";
    if (!tip && names.length == 0) {
      toast.error("Please Add Tip");
      return;
    }
    const formdata = new FormData();
    formdata.append("type", 27);
    formdata.append("name", edit ? tip : names);
    if (!edit) formdata.append("status", true);
    let url = edit
      ? `${URLS.MASTERURL}${addPopup?.id}/edit/`
      : `${URLS.MASTERURL}add/`;
    const res = await post(url, formdata);
    console.log("res edit room category", res);
    if (res?.status === "success") {
      toast.success("Edited successfully");
      getList();
      setNames([]);
      setTip("");
      setAddPopup(false);
    }
  };
  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Tips List",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  if (checkPermission("CAN-STATUS-CHECK_IN"))
                    handleStatus(row.original);
                }}
                className={`${
                  value ? "active-btn" : "deactive-btn"
                } border-0 ms-2`}
                style={{ fontSize: "12px" }}
              >
                {value ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "id",
      Cell: ({ value, row }) => (
        <div className="d-flex ac-js">
          {checkPermission("CAN-EDIT-CHECK_IN") && (
            <button
              onClick={() => {
                setAddPopup(row.original);
                setTip(row.original.name);
              }}
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
          {checkPermission("CAN-DELETE-CHECK_IN") && (
            <button
              onClick={() => {
                setDeletePopup(value);
              }}
              className="cust-btn"
            >
              <img src={delete_icon} alt="" className="mx-2 edit-btn" />
            </button>
          )}
        </div>
      ),
    };
    return checkPermission("CAN-EDIT-CHECK_IN") ||
      checkPermission("CAN-DELETE-CHECK_IN")
      ? [...d, action]
      : d;
  }, [page]);
  return (
    <div>
      <Topbar header={"Master"} subHead={"Check In"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                handleChangeFilter("search", e.target.value);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              value={selectedFilter.search}
            />
            <img alt="" src={Search_icon} className="search" />
          </div>
          {checkPermission("CAN-ADD-CHECK_IN") && (
            <button
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn "
              onClick={() => setAddPopup(true)}
            >
              {" "}
              + Add New
            </button>
          )}
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                {typeof addPopup === "object" ? "Edit" : "Add"}
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setTip("");
                  setNames([]);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="d-flex ac-jb mb-3">
                  <p className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 ">
                    Check In
                  </p>
                </div>
                {typeof addPopup !== "object" && (
                  <div>
                    <div>
                      <div className="d-flex ae-jb input-border p-1">
                        <textarea
                          style={{ maxHeight: "80px" }}
                          // maxLength={250}
                          value={tip}
                          onChange={(e) => {
                            setTip(e.target.value);
                          }}
                          placeholder="Write Here...."
                          className="border-0 mb-3 w-80"
                        />
                        <button
                          onClick={() => {
                            setNames((prev) => [
                              ...prev.filter((i) => i !== tip),
                              tip,
                            ]);
                            setTip("");
                          }}
                          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1"
                          style={{ minWidth: "100px" }}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    <div>
                      {names.length > 0 ? (
                        <ul
                          className="input-border overflow-scroll mt-2"
                          style={{ minHeight: "50px", maxHeight: "200px" }}
                        >
                          {names?.map((name, index) => {
                            return (
                              <li
                                className="d-flex as-js gap-3 mt-2"
                                key={index}
                              >
                                <img
                                  src={arrow_icon}
                                  className="bullet-btn"
                                  alt=""
                                />
                                <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                                  {name}
                                </p>
                                <img
                                  src={delete_icon}
                                  className="delete-btn"
                                  onClick={() => {
                                    setNames((prev) =>
                                      prev.filter((i) => i !== name)
                                    );
                                  }}
                                />
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                {typeof addPopup === "object" && (
                  <input
                    type="url"
                    value={tip}
                    onChange={(e) => {
                      setTip(e.target.value);
                    }}
                    placeholder="Check In "
                    className="input-box"
                  />
                )}
              </div>
            </div>
            <div className="d-flex ac-je px-2 mt-4">
              <button
                onClick={() => {
                  submit();
                }}
                className="submit-btn f2 w-40 p-2 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15"
              >
                {" "}
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      {deletePopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(deletePopup)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setDeletePopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckIn;
